import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import {
  CustomType,
  GetUserCustomProgress$Request,
  GetUserCustomProgress$Response,
  GetUserDailyDiaryProgress$Request,
  GetUserDailyDiaryProgress$Response,
  GetUserDetailedProgress$Response,
  GoalId,
  UserProfileDto,
} from '../../../services/api.types'
import {
  addCustomEntry,
  getCustomProgress,
  getCustomProgressSuccess,
  getDailyProgress,
  getDailyProgressSuccess,
  getProgress,
  getProgressSuccess,
  refreshChallengeResults,
} from './ProgressActions'
import { Action } from 'redux-actions'
import { getUserDto } from '../../../common/auth/authSelectors'
import { getCurrentCompanyGoal, getCurrentGoalActivityList } from '../../Activity/store/ActivityActions'
import { getErrorMsg } from '../../../common/helpers/translations'
import { CustomEntryState } from '../../../components/YumManualEntryForm/YumManualEntryForm'
import { getUserCompanies } from '../../RegisterUser/store/RegisterUserSelectors'
import { store } from '../../../index'
import { IGlobalState } from '../../../Root/store/appReducer'
import { convertDateToTallinnTimeZone } from '../../../common/helpers/date'
import moment from 'moment'
import { CustomTypeCategory } from '../../../services/CustomTypes'
import Bugsnag from '@bugsnag/js'

// Deprecated
function* sagaGetProgress({ payload }: Action<any>) {
  const { startDate, endDate } = payload || {}
  const userDto: UserProfileDto = yield select(getUserDto)
  const userId = userDto.userId

  // Please change Katriito kliinik company progress tab goal from 12k steps a day to 6k steps a day
  const userCompanies = getUserCompanies(store.getState() as any as IGlobalState)
  const isKatriito =
    userCompanies && userCompanies.some(({ companyId }) => companyId === 'b671988d-b6e3-4fac-b737-7b0bdffbaaf8')
  const customStepsGoal = isKatriito ? 6000 : false

  try {
    // @ts-ignore
    const { progressResults }: GetUserDetailedProgress$Response = yield call(
      // @ts-ignore
      api.activity.getUserDetailedProgress,
      {
        userId,
        startDate,
        endDate,
      },
    )

    // TODO: Get progress from here instead.
    /*yield put({
      type: String(getDailyProgress),
      payload: {
        customType: CustomType.STEPS,
        // TODO: It would be more efficient to get the dates originally in the simple date format.
        startDate: moment.utc(startDate).locale('en').format('YYYY-MM-DD'),
        endDate: moment.utc(endDate).locale('en').format('YYYY-MM-DD'),
      },
    })*/

    yield put({ type: String(getProgressSuccess), payload: { startDate, endDate, progressResults, customStepsGoal } })
  } catch (e: any) {
    console.error('GetProgress failed: ', e)
    /*const getProgressErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting progress. Please refresh or contact our support support@yumuuv.com`,
    }
    yield put({ type: String(addNotification), payload: getProgressErrorNotification })*/
  }
}

function* sagaGetCustomProgress({ payload }: Action<GetUserCustomProgress$Request>) {
  // console.log('sagaGetCustomProgress')
  try {
    const { goalId, startDate, endDate, pointsLogicId } = payload
    const { customDiary }: GetUserCustomProgress$Response = yield call(api.activity.getUserCustomProgress, payload)
    yield put({
      type: String(getCustomProgressSuccess),
      payload: { goalId, startDate, endDate, customDiary, pointsLogicId },
    })
  } catch (e: any) {
    console.error('GetCustomProgress failed: ', e)
    /*const getProgressErrorNotification: INotification = {
      type: 'warning',
      content: t`There was a problem within our system while getting progress. Please refresh or contact our support support@yumuuv.com`,
    }
    yield put({ type: String(addNotification), payload: getProgressErrorNotification })*/
  }
}

function* sagaGetDailyProgress({ payload }: Action<GetUserDailyDiaryProgress$Request>) {
  try {
    const { startDate, endDate, customType } = payload
    const { dailyDiary }: GetUserDailyDiaryProgress$Response = yield call(
      api.activity.getUserDailyDiaryProgress,
      payload,
    )
    yield put({ type: String(getDailyProgressSuccess), payload: { startDate, endDate, customType, dailyDiary } })
  } catch (e: any) {
    console.error('GetUserDailyDiaryProgress failed: ', e)
  }
}

function* sagaAddCustomEntry({ payload }: Action<CustomEntryState>) {
  try {
    yield put({ type: String(clearNotification) })
    const {
      amount,
      customType,
      date,
      goalId,

      startDate,
      endDate,
      participating,

      isCollective,
      isActivityIndex,
      manualEntryEnabled,

      pointsLogicId,
      isPoints,
    } = payload

    // Save to DB.
    yield call(api.activity.customEntry, {
      amount,
      customType,
      date,
      goalId,
      pointsLogicId: pointsLogicId || null,
    })

    // Refresh and show new results.
    console.log('Refresh and show new results.')
    yield put({
      type: String(refreshChallengeResults),
      payload: {
        goalId,
        customType,
        startDate,
        endDate,
        participating,
        isCollective,
        isActivityIndex,
        manualEntryEnabled,
        pointsLogicId,
        isPoints,
      },
    })
  } catch (e: any) {
    console.log('CustomEntry failed: ', e)
    /*const content = e.message || getErrorMsg('manual entry')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })*/
    Bugsnag.notify(new Error('CustomEntry error'), function (event) {
      event.context = 'customEntryError'
      event.addMetadata('error', e)
    })
  }
}

export interface RefreshChallengeResultsState {
  customType: CustomType | null
  goalId: GoalId
  endDate: string
  startDate: string
  participating: boolean
  isCollective?: boolean
  isActivityIndex?: boolean
  preventListUpdate?: boolean
  manualEntryEnabled?: boolean
  pointsLogicId: string | null
  pointsLogic?: any[] | null
  isPoints?: boolean
}
function* sagaRefreshChallengeResults({ payload }: Action<RefreshChallengeResultsState>) {
  try {
    const {
      customType,
      goalId,
      startDate,
      endDate,
      participating,
      isCollective,
      isActivityIndex,
      preventListUpdate,
      manualEntryEnabled,
      pointsLogicId,
      pointsLogic,
      isPoints,
    } = payload
    //console.log('sagaRefreshChallengeResults', payload)

    if (isPoints) {
      yield put({
        type: String(getCustomProgress),
        payload: {
          goalId,
          customType: CustomType.POINTS,
          startDate,
          endDate,
        },
      })
    }

    if (customType) {
      if (customType === CustomType.POINTS) {
        // console.log('sagaRefreshChallengeResults POINTS', customType, pointsLogic)
        if (pointsLogic && pointsLogic.length) {
          /*yield put({
            type: String(getCustomProgress),
            payload: {
              goalId,
              customType,
              startDate,
              endDate,
            },
          })*/
          yield all(
            pointsLogic.map((activity) => {
              if (
                [CustomTypeCategory.CUSTOM_SIMPLE, CustomTypeCategory.CUSTOM_WITH_AMOUNT].includes(activity.category)
              ) {
                return put({
                  type: String(getCustomProgress),
                  payload: {
                    goalId,
                    customType: activity.unit,
                    startDate,
                    endDate,
                    pointsLogicId: activity.id,
                  },
                })
              } else {
                return put({
                  type: String(getDailyProgress),
                  payload: {
                    customType: activity.unit,
                    startDate,
                    endDate,
                  },
                })
              }
            }),
          )
        }
      } else if (customType === CustomType.CUSTOM) {
        yield put({
          type: String(getCustomProgress),
          payload: {
            goalId,
            customType,
            startDate,
            endDate,
            // TODO: pointsLogicId
            pointsLogicId,
          },
        })
      } else {
        if (!isActivityIndex || manualEntryEnabled) {
          yield put({
            type: String(getDailyProgress),
            payload: {
              customType,
              startDate,
              endDate,
            },
          })
        }
        if (isActivityIndex) {
          if (manualEntryEnabled) {
            yield put({
              type: String(getDailyProgress),
              payload: {
                customType: CustomType.CALORIES,
                startDate,
                endDate,
              },
            })
            yield put({
              type: String(getDailyProgress),
              payload: {
                customType: CustomType.INTENSIVE_MINUTES,
                startDate,
                endDate,
              },
            })

            // All sync percentages
            yield put({
              type: String(getProgress),
              payload: {
                startDate: convertDateToTallinnTimeZone(moment(startDate).toDate()),
                endDate: convertDateToTallinnTimeZone(moment(endDate).toDate()),
              },
            })
          } else {
            // Just sync percentages
            yield put({
              type: String(getProgress),
              payload: {
                startDate: convertDateToTallinnTimeZone(moment(startDate).toDate()),
                endDate: convertDateToTallinnTimeZone(moment(endDate).toDate()),
              },
            })
          }
        }
      }
    }

    // If was not participating, load goal again with list. Or if it's collective challenge.
    if (!participating || isCollective) {
      yield put({
        type: String(getCurrentCompanyGoal),
        payload: {
          id: goalId,
          silentGoalUpdate: true,
          updateList: !preventListUpdate,
        },
      })
    }
    // If user WAS participating, just refresh the list.
    else if (!preventListUpdate) {
      yield put({
        type: String(getCurrentGoalActivityList),
        payload: {
          goalId,
        },
      })
    }
  } catch (e: any) {
    console.log('RefreshChallengeResults failed: ', e)
    const content = e.message || getErrorMsg('results refresh')
    const notification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

export function* progressSagas() {
  yield all([
    takeEvery(String(getProgress), sagaGetProgress),
    takeEvery(String(getCustomProgress), sagaGetCustomProgress),
    takeEvery(String(getDailyProgress), sagaGetDailyProgress),
    takeEvery(String(addCustomEntry), sagaAddCustomEntry),
    takeEvery(String(refreshChallengeResults), sagaRefreshChallengeResults),
  ])
}
